import { render } from "./ModalCreateMatch.vue?vue&type=template&id=1de7bca8&scoped=true"
import script from "./ModalCreateMatch.vue?vue&type=script&lang=js"
export * from "./ModalCreateMatch.vue?vue&type=script&lang=js"

import "./ModalCreateMatch.vue?vue&type=style&index=0&id=1de7bca8&scoped=true&lang=css"
script.render = render
script.__scopeId = "data-v-1de7bca8"

export default script